import './index.scss';
import React from 'react';
import { useLocation } from 'react-router';
import PermissionChecker from '~/components/permission_checker';
import { useUser } from '~/providers/user';
import Permissions from '~/settings/permissions';
import { SearchType } from '../providers/enums';
import { RightPanelProvider } from '../providers/right_panel_provider';
import MetadataPanel from './metadata_panel';
import ParentDocumentsPanel from './parent_documents_panel';
import SelectedDocumentsPanel from './selected_documents_panel';
const RightPanel = () => {
    const { useNewView } = useUser();
    const { search: locationSearch } = useLocation();
    let activeSearchType = SearchType.Documents;
    const searchParams = new URLSearchParams(locationSearch);
    const filtersString = searchParams.get('filters');
    if (filtersString) {
        const searchFilters = JSON.parse(filtersString);
        if (searchFilters.searchType === SearchType.Clauses) {
            activeSearchType = SearchType.Clauses;
        }
    }
    return (React.createElement(PermissionChecker, { requiredAnyPermissions: [
            Permissions.VIEW_PARENT_DOCUMENTS,
            Permissions.CREATE_DOCUMENT_COMPARISON,
            Permissions.VIEW_FILE_METADATA,
        ] },
        React.createElement(RightPanelProvider, null,
            React.createElement("div", { className: 'right-panel content-library' },
                React.createElement(PermissionChecker, { requiredAnyPermissions: [
                        Permissions.CREATE_DOCUMENT_COMPARISON,
                        Permissions.DOWNLOAD_DOCUMENT,
                    ] },
                    React.createElement(SelectedDocumentsPanel, null)),
                !useNewView && (activeSearchType === SearchType.Documents
                    ? React.createElement(MetadataPanel, { "data-testid": 'search-document-metadata-panel' })
                    : React.createElement(ParentDocumentsPanel, { "data-testid": 'search-parent-documents-panel' }))))));
};
export default RightPanel;
